const paymentFields = [
  {
    name: "course_id",
    label: "Course Title",
    type: "select",
    placeholder: "Course Title",
    value: "title",
    options: [],
  },
  {
    name: "student_id",
    label: "Student Name",
    type: "select",
    placeholder: "Select Student",
    options: [],
  },
  {
    name: "method",
    label: "Payment Method",
    type: "select",
    placeholder: "Select payment method",
    options: [
      {
        title: "Haram Transfer",
        value: "haram_transfer",
      },
      {
        title: "Bank Transfer",
        value: "bank_transfer",
      },
      {
        title: "Cash On Site",
        value: "cash",
      },
    ],
  },
  {
    name: "status",
    label: "Payment Status",
    type: "toggle",
    placeholder: "Select Payment Status",
  },
];

export default paymentFields;
